import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {Broadcaster} from '../app.broadcaster';
import {environment} from '../../environments/environment';

@Injectable()
export class ContestService {
    userToken: any;
    matchInfo: any;
    privateLeagueData: any;
    languageCode: string;
    apiUrl = environment.apiUrl;

    constructor(private httpClient: HttpClient, private router: Router, private broadcaster: Broadcaster) {
        if (localStorage.getItem('save_token')) {
            this.userToken = JSON.parse(localStorage.getItem('save_token'));
        } else {
            this.broadcaster.broadcast('setBgOrNot', false);
            if (this.router.url !== '/terms-n-conditions'
                && this.router.url !== '/live-chat'
                && this.router.url !== '/more/faq'
                // && this.router.url !== '/menu/home'
                // && this.router.url.indexOf('sports/contest-category') === -1
                // && this.router.url.indexOf('sports/create-team') === -1
                // && this.router.url.indexOf('sports/save-team') === -1
                && this.router.url !== '/privacy-policy') {
                this.broadcaster.broadcast('setBgOrNot', false);
                this.router.navigate(['/login']);
                event.preventDefault();
            }
            // this.router.navigate(['/login']);
        }
        this.languageCode = 'en';
        if (localStorage.getItem('saveLanguage')) {
            this.languageCode = JSON.parse(localStorage.getItem('saveLanguage')).language;
        }
    }

    public getSportType() {
        if (localStorage.getItem('match_info')) {
            this.matchInfo = JSON.parse(localStorage.getItem('match_info'));
            return this.matchInfo.matchType;
        }
    }

    // getPollList() {
    //   const headersValue = new HttpHeaders()
    //     .set('UserId', this.userToken.UserId)
    //     .set('ExpireToken', this.userToken.ExpireToken)
    //     .set('AuthExpire', this.userToken.AuthExpire);
    //   return this.httpClient.request(
    //     'get',
    //     this.apiUrl + 'v3/match/getpolllist',
    //     {
    //       headers: headersValue
    //     }
    //   );
    // }

    // getPlayerData(playerId, teamId) {
    //   if (!teamId) {
    //     const headersValue = new HttpHeaders()
    //       .set('UserId', this.userToken.UserId)
    //       .set('playerId', playerId)
    //       .set('ExpireToken', this.userToken.ExpireToken)
    //       .set('AuthExpire', this.userToken.AuthExpire);
    //     return this.httpClient.request(
    //       'get',
    //       this.apiUrl + 'v3/player/liveplayerinfo',
    //       {
    //         headers: headersValue
    //       }
    //     );
    //   } else if (teamId) {
    //     const headersValue = new HttpHeaders()
    //       .set('UserId', this.userToken.UserId)
    //       .set('teamId', teamId)
    //       .set('ExpireToken', this.userToken.ExpireToken)
    //       .set('AuthExpire', this.userToken.AuthExpire);
    //     return this.httpClient.request(
    //       'get',
    //       this.apiUrl + 'v3/player/liveplayerinfolist',
    //       {
    //         headers: headersValue
    //       }
    //     );
    //   }
    // }


    // getMatches(matchInfo: any) {
    //   const headersValue = new HttpHeaders()
    //   // .set('appType', AppConfig.config.appType)
    //     .set('appCode', matchInfo.matchMode)
    //     .set('Version', AppConfig.config.version)
    //     .set('matchType', matchInfo.matchType)
    //     .set('myleauge', '0')
    //     .set('UserId', this.userToken ? this.userToken.UserId : 0)
    //     .set('ExpireToken', this.userToken ? this.userToken.ExpireToken : 0)
    //     .set('AuthExpire', this.userToken ? this.userToken.AuthExpire : 0);
    //   return this.httpClient.request(
    //     'get',
    //     this.apiUrl + 'match/getmatchlist',
    //     {
    //       headers: headersValue
    //     }
    //   );
    // }

    // getPoll(pollId) {
    //   const headersValue = new HttpHeaders()
    //     .set('UserId', this.userToken.UserId)
    //     .set('ExpireToken', this.userToken.ExpireToken)
    //     .set('AuthExpire', this.userToken.AuthExpire)
    //     .set('pollId', pollId);
    //   return this.httpClient.request(
    //     'get',
    //     this.apiUrl + 'v3/match/getpoll',
    //     {
    //       headers: headersValue
    //     }
    //   );
    // }

    // getJoinedContest(matchInfo: any) {
    //   const headersValue = new HttpHeaders()
    //     .set('appCode', matchInfo.matchMode)
    //     .set('matchType', matchInfo.matchType)
    //     .set('myleauge', '1')
    //     .set('UserId', this.userToken.UserId)
    //     .set('ExpireToken', this.userToken.ExpireToken)
    //     .set('AuthExpire', this.userToken.AuthExpire);
    //   return this.httpClient.request(
    //     'get',
    //     this.apiUrl + 'match/getmatchlist',
    //     {
    //       headers: headersValue
    //     }
    //   );
    // }

    // getHeader(matchInfo: any) {
    //   const headersValue = new HttpHeaders()
    //   // .set('appType', AppConfig.config.appType)
    //     .set('appCode', matchInfo.matchMode)
    //     .set('Version', AppConfig.config.version)
    //     .set('matchType', matchInfo.matchType)
    //     .set('UserId', this.userToken ? this.userToken.UserId : 0)
    //     .set('ExpireToken', this.userToken ? this.userToken.ExpireToken : 0)
    //     .set('AuthExpire', this.userToken ? this.userToken.AuthExpire : 0);
    //   return this.httpClient.request(
    //     'get',
    //     // AppConfig.apiUrl + 'match/getheader',
    //     this.apiUrl + 'match/getheadernew',
    //     {
    //       headers: headersValue
    //     }
    //   );
    // }

    // homeData() {
    //   if (localStorage.getItem('match_info')) {
    //     this.matchInfo = JSON.parse(localStorage.getItem('match_info'));
    //   }
    //   return forkJoin(
    //     this.getHeader(this.matchInfo),
    //     this.getMatches(this.matchInfo)
    //   );
    // }

    // getLeagueList(matchId) {
    //   const headersValue = new HttpHeaders()
    //     .set('matchID', matchId)
    //     .set('UserId', this.userToken ? this.userToken.UserId : 0)
    //     .set('ExpireToken', this.userToken ? this.userToken.ExpireToken : 0)
    //     .set('AuthExpire', this.userToken ? this.userToken.AuthExpire : 0);
    //   return this.httpClient.request(
    //     'get',
    //     this.apiUrl + 'leauge/getmatchleague',
    //     {
    //       headers: headersValue
    //     }
    //   );
    // }

    // getNotificationList() {
    //   const headersValue = new HttpHeaders()
    //     .set('UserId', this.userToken.UserId)
    //     .set('ExpireToken', this.userToken.ExpireToken)
    //     .set('AuthExpire', this.userToken.AuthExpire);
    //   return this.httpClient.request(
    //     'post',
    //     this.apiUrl + 'notification/getnotification',
    //     {
    //       headers: headersValue
    //     }
    //   );
    // }

    // getLeagueDetails(leaugeId, matchid) {
    //   const headersValue = new HttpHeaders()
    //     .set('leaugeId', leaugeId)
    //     .set('matchId', matchid)
    //     .set('UserId', this.userToken.UserId)
    //     .set('ExpireToken', this.userToken.ExpireToken)
    //     .set('AuthExpire', this.userToken.AuthExpire);
    //   return this.httpClient.request(
    //     'get',
    //     this.apiUrl + 'leaugedetail/leaderboard',
    //     {
    //       headers: headersValue
    //     }
    //   );
    // }

    // getWinningBreakup(leaugeId) {
    //   const headersValue = new HttpHeaders()
    //     .set('leaugeId', leaugeId)
    //     .set('langCode', this.languageCode)
    //     .set('UserId', this.userToken ? this.userToken.UserId : 0)
    //     .set('ExpireToken', this.userToken ? this.userToken.ExpireToken : 0)
    //     .set('AuthExpire', this.userToken ? this.userToken.AuthExpire : 0);
    //   return this.httpClient.request(
    //     'get',
    //     this.apiUrl + 'leauge/getleaugeandrank',
    //     {
    //       headers: headersValue
    //     }
    //   );
    // }

    // getPlayerInfo(playerId) {
    //   const headersValue = new HttpHeaders()
    //     .set('playerId', playerId)
    //     .set('UserId', this.userToken ? this.userToken.UserId : 0)
    //     .set('ExpireToken', this.userToken ? this.userToken.ExpireToken : 0)
    //     .set('AuthExpire', this.userToken ? this.userToken.AuthExpire : 0);
    //   return this.httpClient.request(
    //     'get',
    //     this.apiUrl + 'player/getplayerinfo',
    //     {
    //       headers: headersValue
    //     }
    //   );
    // }

    // switchTeam(item: any) {
    //   const headersValue = new HttpHeaders()
    //     .set('matchId', item.matchId)
    //     .set('teamId', item.teamId)
    //     .set('leaugeId', item.leaugeId)
    //     .set('oldteamId', item.oldteamId)
    //     .set('UserId', this.userToken.UserId)
    //     .set('ExpireToken', this.userToken.ExpireToken)
    //     .set('AuthExpire', this.userToken.AuthExpire);
    //   return this.httpClient.request(
    //     'post',
    //     this.apiUrl + 'joinleauge/switchteam',
    //     {
    //       headers: headersValue
    //     }
    //   );
    // }


    // joinLeagueAmountDetail(leaugeId, status?) {
    //   let url = 'joinleauge/usableamountandwebnew';
    //   if (localStorage.getItem('privateLeagueData') && status === 'private') {
    //     this.privateLeagueData = JSON.parse(localStorage.getItem('privateLeagueData'));
    //     url = 'joinleauge/usableamount';
    //   }
    //   const headersValue = new HttpHeaders()
    //     .set('leaugeId', leaugeId)
    //     .set('langCode', this.languageCode)
    //     .set('fee', this.privateLeagueData ? this.privateLeagueData.enterFee : '')
    //     .set('member', this.privateLeagueData ? this.privateLeagueData.size : '')
    //     .set('UserId', this.userToken.UserId)
    //     .set('ExpireToken', this.userToken.ExpireToken)
    //     .set('AuthExpire', this.userToken.AuthExpire);
    //   return this.httpClient.request(
    //     'post',
    //     this.apiUrl + url,
    //     {
    //       headers: headersValue
    //     }
    //   );
    // }

    // getLeagueCategoryList(matchId, catId) {
    //   const headersValue = new HttpHeaders()
    //     .set('matchID', matchId)
    //     .set('catId', catId)
    //     .set('UserId', this.userToken.UserId)
    //     .set('ExpireToken', this.userToken.ExpireToken)
    //     .set('AuthExpire', this.userToken.AuthExpire);
    //   return this.httpClient.request(
    //     'get',
    //     this.apiUrl + 'leauge/getmatchCatleague',
    //     {
    //       headers: headersValue
    //     }
    //   );
    // }

    // getPreview(teamId, matchId) {
    //   if (matchId) {
    //     const headersValue = new HttpHeaders()
    //       .set('matchID', matchId)
    //       .set('teamId', teamId)
    //       .set('UserId', this.userToken.UserId)
    //       .set('ExpireToken', this.userToken.ExpireToken)
    //       .set('AuthExpire', this.userToken.AuthExpire);
    //     return this.httpClient.request(
    //       'post',
    //       this.apiUrl + 'teampreview/preview',
    //       {
    //         headers: headersValue
    //       }
    //     );
    //   } else {
    //     const headersValue = new HttpHeaders()
    //       .set('teamId', teamId)
    //       .set('UserId', this.userToken.UserId)
    //       .set('ExpireToken', this.userToken.ExpireToken)
    //       .set('AuthExpire', this.userToken.AuthExpire);
    //     return this.httpClient.request(
    //       'post',
    //       this.apiUrl + 'v2/team/teampreview',
    //       {
    //         headers: headersValue
    //       }
    //     );
    //   }
    //
    // }

    // getJoindedLeague(matchId) {
    //   const headersValue = new HttpHeaders()
    //     .set('matchID', matchId)
    //     .set('UserId', this.userToken.UserId)
    //     .set('ExpireToken', this.userToken.ExpireToken)
    //     .set('AuthExpire', this.userToken.AuthExpire);
    //   return this.httpClient.request(
    //     'get',
    //     this.apiUrl + 'leauge/getmyjoin',
    //     {
    //       headers: headersValue
    //     }
    //   );
    // }

    // getTeamList(matchId, leaugeId, url) {
    //   if (!leaugeId) {
    //     leaugeId = '';
    //   }
    //   const headersValue = new HttpHeaders()
    //     .set('matchID', matchId)
    //     .set('leaugeId', leaugeId)
    //     .set('UserId', this.userToken.UserId)
    //     .set('ExpireToken', this.userToken.ExpireToken)
    //     .set('AuthExpire', this.userToken.AuthExpire);
    //   return this.httpClient.request(
    //     'get',
    //     this.apiUrl + url,
    //     {
    //       headers: headersValue
    //     }
    //   );
    // }

    // submitPoll(pollId, optionId, type) {
    //   const key = type === 'scratchSave' ? 'v3/match/pollsaveshare' : 'v3/match/pollsave';
    //   const url = this.apiUrl + key;
    //   const headersValue = new HttpHeaders()
    //     .set('pollId', pollId)
    //     .set('optionId', optionId)
    //     .set('UserId', this.userToken.UserId)
    //     .set('ExpireToken', this.userToken.ExpireToken)
    //     .set('AuthExpire', this.userToken.AuthExpire);
    //   return this.httpClient.request(
    //     'get',
    //     url,
    //     {
    //       headers: headersValue
    //     }
    //   );
    // }

    // pointDashboard(matchId) {
    //   const headersValue = new HttpHeaders()
    //     .set('matchId', matchId)
    //     .set('UserId', this.userToken.UserId)
    //     .set('ExpireToken', this.userToken.ExpireToken)
    //     .set('AuthExpire', this.userToken.AuthExpire);
    //   return this.httpClient.request(
    //     'get',
    //     this.apiUrl + 'leaugedetail/livemyjoinleague',
    //     {
    //       headers: headersValue
    //     }
    //   );
    // }

    // getPlayerStat(leaugeId) {
    //   const headersValue = new HttpHeaders()
    //     .set('leaugeId', leaugeId)
    //     .set('UserId', this.userToken.UserId)
    //     .set('ExpireToken', this.userToken.ExpireToken)
    //     .set('AuthExpire', this.userToken.AuthExpire);
    //   return this.httpClient.request(
    //     'get',
    //     this.apiUrl + 'leaugedetail/getplayerstates',
    //     {
    //       headers: headersValue
    //     }
    //   );
    // }

    // joinLeague(matchId, leaugeId, teamId, status) {
    //   let url = 'joinleauge/joinleague';
    //   if (localStorage.getItem('privateLeagueData') && status === 'private') {
    //     this.privateLeagueData = JSON.parse(localStorage.getItem('privateLeagueData'));
    //     if (this.privateLeagueData.allow) {
    //       this.privateLeagueData.allow = 1;
    //     } else {
    //       this.privateLeagueData.allow = 0;
    //     }
    //     url = 'private/createprivate';
    //   }
    //   const headersValue = new HttpHeaders()
    //     .set('fee', this.privateLeagueData ? this.privateLeagueData.enterFee : '')
    //     .set('member', this.privateLeagueData ? this.privateLeagueData.size : '')
    //     .set('winningAmount', this.privateLeagueData ? this.privateLeagueData.amount : '')
    //     .set('isMultiple', this.privateLeagueData ? this.privateLeagueData.allow : '')
    //     .set('matchId', matchId)
    //     .set('teamId', teamId)
    //     .set('leaugeId', this.privateLeagueData ? '' : leaugeId)
    //     .set('UserId', this.userToken.UserId)
    //     .set('ExpireToken', this.userToken.ExpireToken)
    //     .set('AuthExpire', this.userToken.AuthExpire);
    //   return this.httpClient.request(
    //     'post',
    //     this.apiUrl + url,
    //     {
    //       headers: headersValue
    //     }
    //   );
    // }


    // getMatchDetails(matchId) {
    //   const headersValue = new HttpHeaders()
    //     .set('matchId', matchId)
    //     .set('UserId', this.userToken ? this.userToken.UserId : 0)
    //     .set('ExpireToken', this.userToken ? this.userToken.ExpireToken : 0)
    //     .set('AuthExpire', this.userToken ? this.userToken.AuthExpire : 0);
    //   return this.httpClient.request(
    //     'get',
    //     this.apiUrl + 'match/getmatch',
    //     {
    //       headers: headersValue
    //     }
    //   );
    // }

    // getPlayerList(matchId) {
    //   const headersValue = new HttpHeaders()
    //     .set('matchId', matchId)
    //     .set('UserId', this.userToken ? this.userToken.UserId : 0)
    //     .set('ExpireToken', this.userToken ? this.userToken.ExpireToken : 0)
    //     .set('AuthExpire', this.userToken ? this.userToken.AuthExpire : 0);
    //   return this.httpClient.request(
    //     'get',
    //     this.apiUrl + 'player/getplayerlist',
    //     {
    //       headers: headersValue
    //     }
    //   );
    // }

    // getEditPlayerList(matchId, teamId) {
    //   const headersValue = new HttpHeaders()
    //     .set('matchID', matchId)
    //     .set('teamId', teamId)
    //     .set('UserId', this.userToken ? this.userToken.UserId : 0)
    //     .set('ExpireToken', this.userToken ? this.userToken.ExpireToken : 0)
    //     .set('AuthExpire', this.userToken ? this.userToken.AuthExpire : 0);
    //   return this.httpClient.request(
    //     'get',
    //     this.apiUrl + 'player/geteditplayerlist',
    //     {
    //       headers: headersValue
    //     }
    //   );
    // }

    // saveTeam(matchId, paylerName, teamId, url) {
    //   if (!teamId) {
    //     teamId = 0;
    //   }
    //   const headersValue = new HttpHeaders()
    //     .set('matchID', matchId)
    //     .set('teamId', teamId)
    //     .set('playersave', paylerName)
    //     .set('UserId', this.userToken.UserId)
    //     .set('ExpireToken', this.userToken.ExpireToken)
    //     .set('AuthExpire', this.userToken.AuthExpire);
    //   return this.httpClient.request(
    //     'post',
    //     this.apiUrl + url,
    //     {
    //       headers: headersValue
    //     }
    //   );
    // }

    // inviteCode(inviteCode) {
    //   const headersValue = new HttpHeaders()
    //     .set('leaugeCode', inviteCode)
    //     .set('UserId', this.userToken.UserId)
    //     .set('ExpireToken', this.userToken.ExpireToken)
    //     .set('AuthExpire', this.userToken.AuthExpire);
    //   return this.httpClient.request(
    //     'post',
    //     this.apiUrl + 'private/leaugecode',
    //     {
    //       headers: headersValue
    //     }
    //   );
    // }

    // getConditions() {
    //     let url = 'en';
    //       if (localStorage.getItem('saveLanguage')) {
    //         url = JSON.parse(localStorage.getItem('saveLanguage')).language;
    //     }
    //     return this.httpClient.request(
    //         'get',
    //         'assets/choose-player-info/' + url + '.json');
    // }
}
